import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const LENS_ROLES = [
  'sundial-role:N_LENS_AUTH_INTERNAL_ALL_INSTITUTION',
  'sundial-role:N_LENS_AUTH_INSTITUTION',
  'sundial-role:N_LENS_USER',
];

export const lensApplication = {
  name: ApplicationNames.LENS,
  url: envConfig.apps.lens,
  roles: LENS_ROLES,
};
